<template>
    <div class="filter">
        <marquee v-if="list.length">
            <span v-for="item in list" :key="item.phone">
                恭喜血裔 {{item.phone}} 获得【{{item | rewardNameFilter}}*{{item.itemcount}}】
            </span>
        </marquee>
        <div v-else class="blank">暂时没有任何动态消息</div>
    </div>
</template>

<script>
import {rewards} from '../../config'
export default {
    name:'Speakers',
    props:['list'],
    data(){
        return {
            timer:null,
            num:0,
            counts:this.list.length
        }
    },
    methods:{
        startPlay(){
            clearInterval(this.timer);

        },
        endPlay(){
            clearInterval(this.timer);
        }
    },
    mounted(){
        this.$nextTick(()=>{
            clearInterval(this.timer);
            this.timer=setInterval(()=>{
                if(this.num<this.counts-1){
                    this.num++;
                }else{
                    this.num=0;
                }
            },2000)
        })
    }
}
</script>

<style lang="scss" scoped>
    .filter {
        height: 0.48rem;
        width: 5.30rem;
        line-height: 0.48rem;
        position: absolute;
        right: 0.62rem;
        color: #0184ff;
        top: 0rem;
        overflow: hidden;
        ul{
            position: relative;
            display: flex;
            left: 0rem;
            transition: all 0.2s;
        }
        li {
            width: 6rem;
            height: 0.48rem;
        }
    }
</style>